// Short-lived "elevation" for password-gated dashboard amounts (ACS Dashboard
// BRD 3 July 2026, "Must login with Password"). The token is minted by
// POST /admin/verify-password after the admin re-enters their password and is
// sent as X-Elevation-Token on the gated dashboard calls. Kept in
// sessionStorage (dropped when the tab closes); expiry is also enforced
// locally so widgets re-mask without waiting for a 401.
const TOKEN_KEY = "elevation_token";
const EXPIRES_KEY = "elevation_expires_at";

const setElevation = (token, expiresInSeconds) => {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(
    EXPIRES_KEY,
    String(Date.now() + expiresInSeconds * 1000)
  );
};

const clearElevation = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(EXPIRES_KEY);
};

const getElevationRemainingMs = () => {
  const expiresAt = Number(sessionStorage.getItem(EXPIRES_KEY));
  if (!expiresAt) return 0;
  return Math.max(0, expiresAt - Date.now());
};

const getElevationToken = () => {
  if (getElevationRemainingMs() <= 0) {
    clearElevation();
    return null;
  }
  return sessionStorage.getItem(TOKEN_KEY);
};

export {
  setElevation,
  clearElevation,
  getElevationToken,
  getElevationRemainingMs,
};
